'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useEffect, useState } from 'react';

const CarouselItem = ({
  category,
  link,
  image,
  imageContent,
  darkMode,
  isAnySelected,
  tabIndex,
}) => {
  const { path } = useCurrentUrl();
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(imageContent?.image ? imageContent : image, 60, 1, 1);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(!!path && !!link && path === link.link);
  }, [path, link]);

  return (
    <>
      <a
        rel={getRel(linkObj)}
        href={`${linkObj.href}`}
        tabIndex={tabIndex}
        className={classNames(
          'rounded-md mx-2 px-2 py-6 flex-1 flex flex-col justify-center',
          'w-[calc(100%-16px)]',
          isAnySelected ? 'mt-2.5 h-[calc(100%-20px)]' : 'mt-0 h-full',
          selected ? 'border-[3px] border-brand-500' : 'border border-neutral-200',
          darkMode ? 'bg-neutral-700' : 'bg-warm-100',
          'lg:max-w-48 lg:mx-auto',
          'hover:text-neutral-800 dark:hover:text-neutral-100',
        )}
      >
        {imgUrl && (
          <LazyLoadImage
            imgComponent={
              /* eslint-disable-next-line @next/next/no-img-element */
              <img src={imgUrl} alt="" />
            }
            className="mx-auto pb-4 max-w-[40px] md:max-w-16"
          />
        )}
        <span
          className={classNames(
            'text-center tra-text-web-heading-7',
            darkMode ? 'text-neutral-100' : 'text-gray-900',
          )}
        >
          {category}
        </span>
      </a>
      {selected && (
        <div className="w-0 h-0 border-l-[10px] border-r-[10px] border-t-[10px] border-l-transparent border-r-transparent border-t-brand-500 mx-auto" />
      )}
    </>
  );
};

export default CarouselItem;
